/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import DashboardContext from "../../../../Context";
import { Table, Space, Spin, Button } from "antd";
import { SHOW_CHILD } from "rc-tree-select";
import ModalCustomerPaymentReceiptDetailReport from './ModalCustomerPaymentReceiptDetailReport';
import ModalCustomerWalletDetailReport from "./ModalCustomerWalletDetailReport";

const ModalCustomerFinancialReport = ({
  showitem,
  handleCloseMoudal,
  userId,
  customerName,
  fromDate,
  toDate,
  handleRefreshGridWorker,
}) => {

  const { sideBardata, authentication, urldashboard } =
    useContext(DashboardContext);

  const [loading, setLoading] = useState(true);
  const [totoalRecord, setTotalRecord] = useState(0);
  const [data, setDataFech] = useState();
  const [showModalPaymentReceiptDetailReport, setShowModalPaymentReceiptDetailReport] = useState(false);
  const [showModalWalletDetailReport, setShowModalWalletDetailReport] = useState(false);
  const [paymentReceiptType, setPaymentReceiptType] = useState('');
  const [walletType, setWalletType] = useState('');
  const [excelLoading, setExcelLoading] = useState(false);
  const [typeTitle, setTypeTitle] = useState('');

  const datafeching = async () => {

    try {

      let url = `/Worker/FinancialReport`;
      let model = { userId: userId, fromDate: fromDate, toDate: toDate };

      const res = await Axios.post(urldashboard + url, model, {
        headers: {
          "Authorization": authentication,
          "Content-Type": "application/json"
        }
      })

      const data = await res.data

      setDataFech(data.data)

      setLoading(false);
    } catch (error) {
      setLoading(false);
      alert('خطایی رخ داده است!')
      setDataFech([]);
    }
  }

  const showModalPaymentReceiptDetail = async (type, title) => {
    setShowModalPaymentReceiptDetailReport(true);
    setPaymentReceiptType(type);
    setTypeTitle(title);
  }

  const showModalWalletDetail = async (type, title) => {
    setShowModalWalletDetailReport(true);
    setWalletType(type);
    setTypeTitle(title);
  }

  const handleClodeModalPaymentReceiptDetailReport = async () => {
    setShowModalPaymentReceiptDetailReport(false);
  }

  const handleClodeModalWalletDetailReport = async () => {
    setShowModalWalletDetailReport(false);
  }

  const getPDF = async () => {

    setExcelLoading(true);

    try {

      let url = `/Worker/getWorkerFinancialPDFReport`;

      let model = { workerId: userId, fromDate: fromDate, toDate: toDate };

      const res = await Axios.post(urldashboard + url, model, {
        headers: {
          "Authorization": authentication,
          "Content-Type": "application/json",
        }, responseType: 'arraybuffer'
      })

      let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // change resultByte to bytes
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "WorkerFinancialReport.pdf";
      link.click();

      setExcelLoading(false);
    } catch (error) {
      setExcelLoading(false);
      //handelerrors(error)
    }
  }

  const tableStyle = {
    border: '1px solid black',
    padding: 15,
    'text-align': 'center'
  }

  useEffect(() => {

    datafeching()

    return () => { };
  }, [userId]);


  return (
    <div>

      {showModalPaymentReceiptDetailReport ? (
        <ModalCustomerPaymentReceiptDetailReport
          showitem={showModalPaymentReceiptDetailReport}
          handleCloseMoudal={() => handleClodeModalPaymentReceiptDetailReport()}
          userId={userId}
          paymentReceiptType={paymentReceiptType}
          fromDate={fromDate}
          toDate={toDate}
          headerTitle={typeTitle}
        />
      ) : null}

      {showModalWalletDetailReport ? (
        <ModalCustomerWalletDetailReport
          showitem={showModalWalletDetailReport}
          handleCloseMoudal={() => handleClodeModalWalletDetailReport()}
          userId={userId}
          walletType={walletType}
          fromDate={fromDate}
          toDate={toDate}
          headerTitle={typeTitle}
        />
      ) : null}

      <Modal show={showitem} onHide={handleCloseMoudal} size={"lg"}>
        <Modal.Header>
          <Modal.Title>
            {
              data?.fromDate != "" ?
                <span> گزارش مالی از {data?.fromDate} تا {data?.toDate}</span> : <span>گزارش مالی</span>
            }
          </Modal.Title>

          <div style={{ width: '50%', display: 'flex' }}>

            {
              excelLoading ? <i class="fas fa-sync fa-spin">
                <i style={{ fontSize: '40px', color: 'red' }} class="fa fa-file-pdf-o" aria-hidden="true"></i>
              </i> : <i style={{ fontSize: '40px', color: 'red' }} onClick={() => getPDF()} class="fa fa-file-pdf-o" aria-hidden="true"></i>
            }


            <i
              className="fa fa-times mr-auto"
              style={{ fontSize: "16px", cursor: "pointer" }}
              onClick={handleCloseMoudal}
              aria-hidden="true"
            ></i>
          </div>


        </Modal.Header>

        <Modal.Body style={{ textAlign: 'center' }}>

          {
            loading ?
              <Space size="middle">
                <Spin size="large" />
              </Space> :

              <div className='row'>

                <div className="col-md-4">

                  <table style={{ tableStyle, width: '100%' }}>
                    <tr style={{ tableStyle, backgroundColor: 'green', color: 'white' }}>
                      <th style={tableStyle}>ردیف</th>
                      <th style={tableStyle}>افزایشی ها</th>
                      <th style={tableStyle}>جمع کل</th>
                    </tr>

                    {
                      data?.increaseItems?.map(item => {
                        return (<tr>
                          <td style={tableStyle}>{data?.increaseItems?.indexOf(item) + 1}</td>
                          <td style={tableStyle}>{item?.text}
                            <i onClick={() => showModalWalletDetail(item?.walletType, item?.text)} style={{ marginRight: 10 }} class="fa fa-bars" aria-hidden="true"></i>
                          </td>
                          <td style={tableStyle}> {(item?.value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</td>
                        </tr>)

                      })
                    }

                    <tr>
                      <th colspan="2" style={tableStyle}>جمع کل</th>
                      <th style={tableStyle}>{(data?.totalIncreases?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</th>
                    </tr>

                  </table>

                </div>

                <div className="col-md-4">

                  <table style={{ tableStyle, width: '100%' }}>
                    <tr style={{ tableStyle, backgroundColor: 'red', color: 'white' }}>
                      <th style={tableStyle}>ردیف</th>
                      <th style={tableStyle}>کاهشی ها</th>
                      <th style={tableStyle}>جمع کل</th>
                    </tr>
                    {
                      data?.decreaseItems?.map(item => {
                        return (<tr>
                          <td style={tableStyle}>{data?.decreaseItems?.indexOf(item) + 1}</td>
                          <td style={tableStyle}>{item?.text}
                            <i onClick={() => showModalWalletDetail(item?.walletType, item?.text)} style={{ marginRight: 10 }} class="fa fa-bars" aria-hidden="true"></i>
                          </td>
                          <td style={tableStyle}> {(item?.value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</td>
                        </tr>)

                      })
                    }

                    <tr>
                      <th colspan="2" style={tableStyle}>جمع کل</th>
                      <th style={tableStyle}>{(data?.totalDecreases?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</th>
                    </tr>

                  </table>

                </div>

                <div className="col-md-4">

                  <table style={{ tableStyle, width: '100%' }}>
                    <tr style={{ tableStyle, backgroundColor: '#ff8800', color: 'white' }}>
                      <th style={tableStyle}>ردیف</th>
                      <th style={tableStyle}>بدهکاری ها</th>
                      <th style={tableStyle}>جمع کل</th>
                    </tr>
                    {
                      data?.paymentReceiptItems?.map(item => {
                        return (<tr>
                          <td style={tableStyle}>{data?.paymentReceiptItems?.indexOf(item) + 1}</td>
                          <td style={tableStyle}>{item?.text}

                            <i onClick={() => showModalPaymentReceiptDetail(item?.paymentReceiptType, item?.text)} style={{ marginRight: 10 }} class="fa fa-bars" aria-hidden="true"></i>

                          </td>
                          <td style={tableStyle}> {(item?.value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</td>
                        </tr>)

                      })
                    }

                    <tr>
                      <th colspan="2" style={tableStyle}>جمع کل</th>
                      <th style={tableStyle}>{(data?.totalPaymentReceipts.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</th>
                    </tr>

                  </table>

                </div>


                <div className="col-md-4" style={{ marginTop: 15 }}>

                  <table style={{ tableStyle, width: '100%' }}>
                    <tr style={{ tableStyle, backgroundColor: 'rgb(50 46 41)', color: 'white' }}>
                      <th style={tableStyle}>مانده</th>
                      <th style={tableStyle}>وضعیت</th>
                    </tr>


                    <td style={tableStyle}><span style={{ fontWight: 'bold', fontSize: 22 }}>{data?.accountBalance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></td>
                    <td style={tableStyle}><span style={{ fontWight: 'bold', fontSize: 22 }}>{data?.accountBalanceStatusText}</span></td>

                  </table>

                </div>

              </div>
          }



        </Modal.Body>

        <Modal.Footer>

        </Modal.Footer>

      </Modal>
    </div>

  );
};

export default ModalCustomerFinancialReport;
